import './index.css'
export default function NavigationBar() {
  
  return (
    <div className="navigate-box">
      <img className='logo' src='https://jmqfile.oss-cn-hangzhou.aliyuncs.com/admin/0/202365/0bd4734224be4986ba696b6e8c6b914e.png' alt=''></img>
      <div className="navigate-content">
        <div className="btn-box">
          <a className="a-style margin-right" href='https://www.jinmokeji.cn/'><span>首页</span>/Home Page</a>
          <a className="a-style margin-right" href='https://www.jinmokeji.cn/productOntrodution'> <span>产品介绍</span>/Product Ontrodution</a>
          <a className="a-style margin-right" style={{ color: '#46D2A1' }}><span style={{ color: '#46D2A1' }}>投放场景</span>/Launch Scenarios</a>
          <a className="a-style" href='https://www.jinmokeji.cn/joinUs'><span>加入我们</span>/Join Us</a>
        </div>
      </div>
      <div className='w-[174px]'></div>
    </div>
  )
}